import DesignGraphiqueLandingPage from './DesignGraphiqueLandingPage';

function App() {
  return <DesignGraphiqueLandingPage />;
}

export default App;